import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-pricing-card',
  styleUrls: [],
  shadow: false,
})
export class DdaImageCard {
  @Prop() image_src: string;
  @Prop() image_chip_icon: string;
  @Prop() image_chip_icon_family: string;
  @Prop() image_chip_label: string;
  @Prop() image_chip_icon_size: string;

  @Prop() header_text: string;
  @Prop() header_text_icon: string;
  @Prop() card_header_icon_id: string;
  @Prop() body_text_icon: string;
  @Prop() body_text: string;
  @Prop() price_text: string;
  @Prop() price_period: string;

  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;

  @Prop({ mutable: true }) chip_list: {
    chip_text: string;
  }[] = [];

  @Prop() clickHandler?: (event: MouseEvent) => void;
  

  componentWillRender() {
    const attrValue = (document.querySelector('dda-pricing-card') as HTMLElement)?.getAttribute('data-chip-list');
    if (attrValue) {
      try {
        const parsed = JSON.parse(attrValue);
        if (Array.isArray(parsed)) {
          this.chip_list = parsed;
        }
      } catch (e) {
        console.warn('Invalid chip_list JSON:', e);
      }
    }
  }

  render() {
    const cardClass = ['dda-card', this.custom_class].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={cardClass}>
          <div class="dda-row no-gutters">
            <div class="dda-col-sm-4 dda-p-0 dda-position-relative">
              <img src={this.image_src} class="dda-card-img" alt="card-img-1" />
              <dda-chip
                bg_color="grey"
                image_chip_label={this.image_chip_label}
                image_chip_icon={this.image_chip_icon}
                image_chip_icon_family={this.image_chip_icon_family}
                image_chip_icon_size={this.image_chip_icon_size}
                size="md"
                rounded="circle"
                custom_class="image-chip"
              ></dda-chip>
            </div>
            <div class="dda-col-sm-8 dda-p-0">
              <div class="dda-card-body ">
                <div class="dda-d-flex dda-align-items-start dda-justify-content-between">
                  <h5 class="dda-card-title dda-d-flex ">{this.header_text}</h5>
                  <div>
                    <dda-button
                      button_color="onsurface-link"
                      // start_icon="more_horiz"
                      start_icon={this.header_text_icon}
                      end_icon=""
                      custom_class=""
                      component_mode=""
                      button_id={this.card_header_icon_id}
                      aria_label="button"
                      onClick={() => console.log('clicked')} 
                      button_name="button"
                    ></dda-button>
                  </div>
                </div>
                <p class="dda-card-text dda-d-flex dda-align-items-start dda-gap-2">
                  {this.body_text_icon && (
                    <i class="material-icons material-symbols-outlined mr-2" aria-hidden="true">
                      {this.body_text_icon}
                    </i>
                  )}
                  {this.body_text}
                </p>
                <div class="dda-d-flex dda-items-center">
                  <h5 class="dda-card-title dda-color-primary">{this.price_text}</h5>
                  <p class="dda-color-neutralvariant"> / {this.price_period}</p>
                </div>

                <ul class="chips-container">
                  {this.chip_list.map((chip, index) => (

                    <li key={index}>
                      <dda-chip
                        chip_text={chip.chip_text}
                        chip_icon="fiber_manual_record"
                        chip_icon_family="material-icons"
                        chip_icon_size="sm"
                        rounded="circle"
                        size="lg"
                        bg_color="grey"
                      ></dda-chip>
                    </li>
                    
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
